import React from "react";

/* content for main Hero section: */
import HomeHeroIconsDesktopSvg from "./images/home-hero-icons-desktop.svg";
import HomeHeroIconsMobileSvg from "./images/home-hero-icons-mobile.svg";

export const heroTitle = "Icons and Photos For Everything";

export const heroSvgDesktop = HomeHeroIconsDesktopSvg;

export const heroSvgMobile = HomeHeroIconsMobileSvg;

/* content for Collections: */

// Collection Images:
import Covid19 from "./images/covid-19.png";
import AtTheOffice from "./images/at-the-office.png";
import Pets from "./images/pets.png";
import BackToSchool from "./images/back-to-school.png";

import IconSetBrowse from "./images/icon-set-browse.svg";
import IconSetEducation from "./images/icon-set-education.svg";
import IconSetFuturisticTechnology from "./images/icon-set-futuristic-technology.svg";
import IconSetIconathonSvg from "./images/icon-set-iconathon.svg";
import IconSetPlants from "./images/icon-set-plants.svg";

export const collectionsTitle =
    "Noun Project is building a global visual language that unites us.";

export const collections = [
    {
        title: "Iconathon",
        subtitle: "Redefining Women Collection",
        url: "/Iconathon1/collection/redefining-women/",
        imageSrc: IconSetIconathonSvg,
        type: "darkMode"
    },
    {
        title: "Back to School",
        url: "/search/photos/?q=school",
        imageSrc: BackToSchool,
        isPhoto: true
    },
    {
        title: "Plants",
        url: "/search/collection/?q=plants",
        imageSrc: IconSetPlants
    },
    {
        title: "Pets",
        url: "/browse/campaign/pets-12/",
        imageSrc: Pets,
        isPhoto: true
    },
    {
        title: "Futuristic Technology",
        url: "/winnievinzence/collection/futuristic-technology/",
        imageSrc: IconSetFuturisticTechnology
    },
    {
        title: "At the Office",
        url: "/search/photos/?q=office",
        imageSrc: AtTheOffice,
        isPhoto: true
    },
    {
        title: "Education",
        url: "/karimow-25/collection/education-learning-school/",
        imageSrc: IconSetEducation
    },
    {
        title: "COVID-19",
        url: "/browse/term/photos/covid/",
        imageSrc: Covid19,
        isPhoto: true
    },
    {
        title: "Browse New Icons",
        url: "/browse/",
        imageSrc: IconSetBrowse
    }
];

/* content for Recent Posts: */
import RecentPostsImg1 from "./images/recent-posts-20-top-designers.gif";
import RecentPostsImg2 from "./images/recent-posts-idara-ekpoh.png";
import RecentPostsImg3 from "./images/recent-posts-rule-of-thirds.png";

export const recentPostsTitle = "Recent Posts";

export const recentPosts = [
    {
        title: "20 Top Designers and Illustrators",
        category: "Spotlight",
        imgSrc: RecentPostsImg1,
        url:
            "https://thelist.thenounproject.com/?utm_source=nphome&utm_medium=post&utm_campaign=the_list&utm_term=fall_2021",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Idara Ekpoh",
        category: "Photographer Feature",
        imgSrc: RecentPostsImg2,
        url:
            "https://blog.thenounproject.com/education-and-inspiration-with-photographer-idara-ekpoh-9899c29707b3?source=friends_link&sk=d190dd56db69a5386bb91d7ab80a88a7",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Using the Rule of Thirds in Design",
        category: "Tutorial",
        imgSrc: RecentPostsImg3,
        url:
            "https://blog.thenounproject.com/using-the-rule-of-thirds-in-design-82a444307746?source=friends_link&sk=f7ff16bf33f117866d2aa96a3d64a8ad",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    }
];

/* Content for Promo section: */
import { PRICING, appsAndPluginsPath, apiMarketingPagePath } from "data/links";
import Payouts from "core/ReusableIcons/Payouts";
import Computer from "core/ReusableIcons/Computer";
import Api from "core/ReusableIcons/Api";

import AppAppleSvg from "./images/AppAppleSvg";
import AppAdobeSvg from "./images/AppAdobeSvg";
import AppMicrosoftSvg from "./images/AppMicrosoftSvg";
import AppGsuiteSvg from "./images/AppGsuiteSvg";

export const promo = [
    {
        url: PRICING,
        iconName: <Payouts size="xl" title="Pricing &amp; Licenses" />,
        title: "Pricing & Licenses",
        description:
            "All images available as free downloads. Purchase a royalty-free license to support artists and get more options.",
        learnMoreContent: "Learn More"
    },
    {
        url: appsAndPluginsPath,
        iconName: <Computer size="xl" title="Apps &amp; Plugins" />,
        title: "Apps & Plugins",
        description:
            "Drag and drop icons into the software you use. Access vector, png, & pdf from Mac, PowerPoint, Adobe, Google, more.",
        learnMoreContent: [
            {
                icon: <AppAppleSvg title="Apple" />
            },
            {
                icon: <AppAdobeSvg title="Adobe" />
            },
            {
                icon: <AppMicrosoftSvg title="Microsoft" />
            },
            {
                icon: <AppGsuiteSvg title="GSuite" />
            }
        ]
    },
    {
        url: apiMarketingPagePath,
        iconName: <Api size="xl" title="API" />,
        title: "API",
        description:
            "Access the entire icon collection via our REST API. Reliably supports growth stage to enterprise clients. ",
        learnMoreContent: "Learn More"
    }
];
